import { useSelector } from '../../modules/useSelector';
import useTranslations, { T } from './useTranslations';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx } from "react/jsx-runtime";
const translation = WrappedComponent => {
  const TranslationWrapper = props => {
    const trl = useSelector(({
      trl
    }) => trl);
    const defaultLang = useSelector(({
      langs
    }) => langs[0]);
    const trls = useTranslations(WrappedComponent, trl, defaultLang, !!process.env.SSR);
    return /*#__PURE__*/_jsx(T, {
      ...props,
      trls: trls,
      Element: WrappedComponent
    });
  };
  return TranslationWrapper;
};
export default translation;
//# sourceMappingURL=index.js.map